var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFoodfork = function SvgFoodfork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#82460B",
    clipPath: "url(#foodfork_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 4.286A4.036 4.036 0 0 0 12.286 0a4.035 4.035 0 0 0-3.714 4.286 4.245 4.245 0 0 0 2.664 4.1.29.29 0 0 1 .193.27v6.487a.857.857 0 1 0 1.714 0V8.656a.29.29 0 0 1 .193-.27A4.24 4.24 0 0 0 16 4.285M6.571 0a.857.857 0 0 0-.857.857v2.857A1.98 1.98 0 0 1 5.047 5.2a.285.285 0 0 1-.476-.217V.857a.857.857 0 0 0-1.714 0v4.126a.288.288 0 0 1-.33.283.3.3 0 0 1-.145-.07 1.98 1.98 0 0 1-.668-1.482V.857A.857.857 0 0 0 0 .857v2.857a3.71 3.71 0 0 0 2.654 3.55.29.29 0 0 1 .203.279v7.6a.857.857 0 1 0 1.714 0v-7.6a.29.29 0 0 1 .204-.274 3.71 3.71 0 0 0 2.654-3.555V.857A.857.857 0 0 0 6.57 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "foodfork_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgFoodfork;